import React, { useEffect, useCallback } from 'react';
import { useAiRovoCurrentRouteConfigurationStoreActions } from '@jira/ai-rovo_actions-store/src/aiRovoCurrentRouteConfigurationStore.tsx';
import messages from '@jira/ai-rovo__actions-permissions/src/messages.tsx';
import { usePublish } from '@atlaskit/rovo-triggers';
import AiChatIcon from '@atlaskit/icon/core/ai-chat';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';

export const AiRovoPermissionsNudgesProvider = (): null => {
	const { formatMessage } = useIntl();
	const { updateConfiguration } = useAiRovoCurrentRouteConfigurationStoreActions();
	const publish = usePublish('ai-mate');

	const formatPrompt = useCallback(
		(message: Parameters<typeof formatMessage>[0]): string => {
			return `/manage-jira-permissions ${formatMessage(message)}`;
		},
		[formatMessage],
	);

	useEffect(() => {
		if (!fg('permissions_ai_rovo_nudge_and_context')) return;

		updateConfiguration({
			nudges: [
				{
					id: 'ai-rovo.permissions-nudge.who-can-access-project-what-roles',
					title: formatPrompt(messages.whoCanAccessProjectWhatRoles),
					description: formatPrompt(messages.whoCanAccessProjectWhatRoles),
					icon: (
						<AiChatIcon label={formatPrompt(messages.whoCanAccessProjectWhatRoles)} size="medium" />
					),
					nudgeIcon: () => (
						<AiChatIcon label={formatPrompt(messages.whoCanAccessProjectWhatRoles)} size="medium" />
					),
					onClick: () => {
						publish({
							type: 'chat-new',
							product: 'jira',
							source: 'permissions-rovo-nudge',
							data: {
								name: formatPrompt(messages.whoCanAccessProjectWhatRoles),
								dialogues: [],
								prompt: formatPrompt(messages.whoCanAccessProjectWhatRoles),
							},
						});
					},
					sourceId: 'jira-ai-rovo-button',
					status: 'new',
				},
				{
					id: 'ai-rovo.permissions-nudge.why-user-cannot-view-edit-issues',
					title: formatPrompt(messages.whyUserCannotViewEditIssues),
					description: formatPrompt(messages.whyUserCannotViewEditIssues),
					icon: (
						<AiChatIcon label={formatPrompt(messages.whyUserCannotViewEditIssues)} size="medium" />
					),
					nudgeIcon: () => (
						<AiChatIcon label={formatPrompt(messages.whyUserCannotViewEditIssues)} size="medium" />
					),
					onClick: () => {
						publish({
							type: 'chat-new',
							product: 'jira',
							source: 'permissions-rovo-nudge',
							data: {
								name: formatPrompt(messages.whyUserCannotViewEditIssues),
								dialogues: [],
								prompt: formatPrompt(messages.whyUserCannotViewEditIssues),
							},
						});
					},
					sourceId: 'jira-ai-rovo-button',
					status: 'new',
				},
				{
					id: 'ai-rovo.permissions-nudge.who-has-project-admin-sprint-management-permissions',
					title: formatPrompt(messages.whoHasProjectAdminOrManageSprintsPermissions),
					description: formatPrompt(messages.whoHasProjectAdminOrManageSprintsPermissions),
					icon: (
						<AiChatIcon
							label={formatPrompt(messages.whoHasProjectAdminOrManageSprintsPermissions)}
							size="medium"
						/>
					),
					nudgeIcon: () => (
						<AiChatIcon
							label={formatPrompt(messages.whoHasProjectAdminOrManageSprintsPermissions)}
							size="medium"
						/>
					),
					onClick: () => {
						publish({
							type: 'chat-new',
							product: 'jira',
							source: 'permissions-rovo-nudge',
							data: {
								name: formatPrompt(messages.whoHasProjectAdminOrManageSprintsPermissions),
								dialogues: [],
								prompt: formatPrompt(messages.whoHasProjectAdminOrManageSprintsPermissions),
							},
						});
					},
					sourceId: 'jira-ai-rovo-button',
					status: 'new',
				},
			],
		});
	}, [formatMessage, formatPrompt, updateConfiguration, publish]);

	return null;
};
